var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHiddenKeywors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141816",
    transform: "translate(8 152.799)",
    fill: "#5e708d",
    stroke: "#707070",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1550",
    transform: "translate(-8 -152.799)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 141815",
    fill: "none",
    d: "M8 152.799h24v24H8z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "icons Q2",
    fill: "#5e708d"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48384",
    d: "M20 155.799a9 9 0 1 1-9 9 9 9 0 0 1 9-9m0-2a10.95 10.95 0 1 0 7.793 3.207A11 11 0 0 0 20 153.799Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 48385",
    d: "m21.4 164.799 2.8-2.75a1.05 1.05 0 0 0 .1-1.35.95.95 0 0 0-1.5-.1l-2.8 2.8-2.8-2.8a.95.95 0 0 0-1.5.1 1.05 1.05 0 0 0 .1 1.35l2.8 2.75-2.8 2.75a1.05 1.05 0 0 0-.1 1.35.95.95 0 0 0 1.5.1l2.8-2.8 2.8 2.8a.95.95 0 0 0 1.5-.1 1.05 1.05 0 0 0-.1-1.35Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenKeywors);
export default __webpack_public_path__ + "static/media/Hidden_Keywors.ba960d342ad1ca9d3f8f24bcb02e461c.svg";
export { ForwardRef as ReactComponent };